import { type LegalEntitySummary } from '@webapp/core/entities/internal/LegalEntitySummary'
import { type LegalEntitySummaryApiModel } from '../api-models/LegalEntitySummaryApiModel'

export const mapLegalEntitySummary = (
  legalEntity: LegalEntitySummaryApiModel
): LegalEntitySummary => ({
  id: legalEntity.id,
  uuid: legalEntity.uuid,
  name: legalEntity.name,
})
